import React, { useState } from 'react';
import { toast } from 'react-hot-toast';

const Ferias = () => {
  const [filtros, setFiltros] = useState({
    page: 1,
    limit: 10,
    status: '',
    tipo: '',
    colaborador: '',
    dataInicio: '',
    dataFim: ''
  });
  
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  // const [feriasSelecionada, setFeriasSelecionada] = useState(null);
  const [formData, setFormData] = useState({
    colaborador: '',
    tipo: 'ferias',
    periodo: {
      inicio: '',
      fim: ''
    },
    diasSolicitados: '',
    diasDisponiveis: '',
    status: 'pendente',
    observacoes: ''
  });


  // Simular dados para demonstração
  const ferias = [
    {
      _id: '1',
      colaborador: 'João Silva',
      tipo: 'ferias',
      periodo: {
        inicio: '2024-02-01',
        fim: '2024-02-15'
      },
      diasSolicitados: 15,
      diasDisponiveis: 30,
      status: 'aprovado',
      observacoes: 'Férias de verão'
    },
    {
      _id: '2',
      colaborador: 'Maria Santos',
      tipo: 'abono',
      periodo: {
        inicio: '2024-01-20',
        fim: '2024-01-22'
      },
      diasSolicitados: 3,
      diasDisponiveis: 5,
      status: 'pendente',
      observacoes: 'Abono de férias'
    }
  ];

  const handleCreate = () => {
    setModalMode('create');
    // setFeriasSelecionada(null);
    setFormData({
      colaborador: '',
      tipo: 'ferias',
      periodo: {
        inicio: '',
        fim: ''
      },
      diasSolicitados: '',
      diasDisponiveis: '',
      status: 'pendente',
      observacoes: ''
    });
    setModalOpen(true);
  };

  const handleEdit = (ferias) => {
    setModalMode('edit');
    // setFeriasSelecionada(ferias);
    setFormData({
      colaborador: ferias.colaborador,
      tipo: ferias.tipo,
      periodo: {
        inicio: ferias.periodo.inicio,
        fim: ferias.periodo.fim
      },
      diasSolicitados: ferias.diasSolicitados,
      diasDisponiveis: ferias.diasDisponiveis,
      status: ferias.status,
      observacoes: ferias.observacoes
    });
    setModalOpen(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você implementaria a lógica de salvar
    toast.success(modalMode === 'create' ? 'Férias criadas com sucesso!' : 'Férias atualizadas com sucesso!');
    setModalOpen(false);
  };

  const handleAprovar = (id) => {
    // Aqui você implementaria a lógica de aprovação
    toast.success('Férias aprovadas com sucesso!');
  };

  const handleRecusar = (id, motivo) => {
    // Aqui você implementaria a lógica de recusa
    toast.success('Férias recusadas com sucesso!');
  };

  const getTipoText = (tipo) => {
    const tipos = {
      'ferias': 'Férias',
      'abono': 'Abono',
      'ferias_antecipadas': 'Férias Antecipadas'
    };
    return tipos[tipo] || tipo;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pendente': return 'bg-yellow-100 text-yellow-800';
      case 'aprovado': return 'bg-green-100 text-green-800';
      case 'recusado': return 'bg-red-100 text-red-800';
      case 'em_andamento': return 'bg-blue-100 text-blue-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pendente': return 'Pendente';
      case 'aprovado': return 'Aprovado';
      case 'recusado': return 'Recusado';
      case 'em_andamento': return 'Em Andamento';
      default: return 'Desconhecido';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Férias</h1>
            <p className="text-gray-600">Controle de férias dos colaboradores</p>
          </div>
          <button
            onClick={handleCreate}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center"
          >
            <span className="mr-2">➕</span>
            Nova Solicitação
          </button>
        </div>
      </div>

      {/* Filtros */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <form className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={filtros.status}
              onChange={(e) => setFiltros(prev => ({ ...prev, status: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Todos</option>
              <option value="pendente">Pendente</option>
              <option value="aprovado">Aprovado</option>
              <option value="recusado">Recusado</option>
              <option value="em_andamento">Em Andamento</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tipo
            </label>
            <select
              value={filtros.tipo}
              onChange={(e) => setFiltros(prev => ({ ...prev, tipo: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Todos</option>
              <option value="ferias">Férias</option>
              <option value="abono">Abono</option>
              <option value="ferias_antecipadas">Férias Antecipadas</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Colaborador
            </label>
            <input
              type="text"
              placeholder="Nome do colaborador"
              value={filtros.colaborador}
              onChange={(e) => setFiltros(prev => ({ ...prev, colaborador: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div className="flex items-end">
            <button
              type="submit"
              className="w-full bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md"
            >
              🔍 Filtrar
            </button>
          </div>
        </form>
      </div>

      {/* Lista de Férias */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Colaborador
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Período
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Dias
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {ferias.map((ferias) => (
                <tr key={ferias._id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {ferias.colaborador}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {getTipoText(ferias.tipo)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {new Date(ferias.periodo.inicio).toLocaleDateString('pt-BR')} a {new Date(ferias.periodo.fim).toLocaleDateString('pt-BR')}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {ferias.diasSolicitados} / {ferias.diasDisponiveis} dias
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(ferias.status)}`}>
                      {getStatusText(ferias.status)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      <button
                        onClick={() => handleEdit(ferias)}
                        className="text-blue-600 hover:text-blue-900"
                        title="Editar"
                      >
                        ✏️
                      </button>
                      
                      {ferias.status === 'pendente' && (
                        <>
                          <button
                            onClick={() => handleAprovar(ferias._id)}
                            className="text-green-600 hover:text-green-900"
                            title="Aprovar"
                          >
                            ✅
                          </button>
                          <button
                            onClick={() => handleRecusar(ferias._id)}
                            className="text-red-600 hover:text-red-900"
                            title="Recusar"
                          >
                            ❌
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal de Férias */}
      {modalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                {modalMode === 'create' ? 'Nova Solicitação de Férias' : 'Editar Férias'}
              </h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Colaborador
                  </label>
                  <input
                    type="text"
                    value={formData.colaborador}
                    onChange={(e) => setFormData(prev => ({ ...prev, colaborador: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tipo
                  </label>
                  <select
                    value={formData.tipo}
                    onChange={(e) => setFormData(prev => ({ ...prev, tipo: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="ferias">Férias</option>
                    <option value="abono">Abono</option>
                    <option value="ferias_antecipadas">Férias Antecipadas</option>
                  </select>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Data Início
                    </label>
                    <input
                      type="date"
                      value={formData.periodo.inicio}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        periodo: { ...prev.periodo, inicio: e.target.value }
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Data Fim
                    </label>
                    <input
                      type="date"
                      value={formData.periodo.fim}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        periodo: { ...prev.periodo, fim: e.target.value }
                      }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Dias Solicitados
                    </label>
                    <input
                      type="number"
                      value={formData.diasSolicitados}
                      onChange={(e) => setFormData(prev => ({ ...prev, diasSolicitados: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Dias Disponíveis
                    </label>
                    <input
                      type="number"
                      value={formData.diasDisponiveis}
                      onChange={(e) => setFormData(prev => ({ ...prev, diasDisponiveis: e.target.value }))}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    value={formData.status}
                    onChange={(e) => setFormData(prev => ({ ...prev, status: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="pendente">Pendente</option>
                    <option value="aprovado">Aprovado</option>
                    <option value="recusado">Recusado</option>
                    <option value="em_andamento">Em Andamento</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Observações
                  </label>
                  <textarea
                    value={formData.observacoes}
                    onChange={(e) => setFormData(prev => ({ ...prev, observacoes: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows="3"
                  />
                </div>
                
                <div className="flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => setModalOpen(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  >
                    {modalMode === 'create' ? 'Criar' : 'Atualizar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ferias;